<template>
  <main class="l-main p-seo">
    <TitleMain
      icon="seo"
      faq="/sections/360001240095"
      howTo="/sections/4404631666447"
    >
      <span class="title">SEO課題チェック</span>
      <span class="description">
        SEOの観点からページを評価し、<br />発見した課題に対してアドバイスを行います。
      </span>
    </TitleMain>
    <div class="l-container">
      <div class="l-toolBlock">
        <ButtonToProjects />
        <Button
          v-if="$route.name !== 'seo'"
          :to="{
            name: 'seo'
          }"
          variant="light"
          icon="pageback"
          radius
        >
          SEO課題チェック一覧に戻る
        </Button>
        <Breadcrumb />
      </div>
      <router-view :date="date" :id="id" :project="project" />
    </div>
  </main>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import Button from '@/components/Button';
import ButtonToProjects from '@/components/ButtonToProjects';
import TitleMain from '@/components/TitleMain';

export default {
  props: ['date', 'id', 'project'],
  components: {
    Breadcrumb,
    Button,
    ButtonToProjects,
    TitleMain
  }
};
</script>
